module.exports = __webpack_public_path__ + "img/img-adduser-index.defffe70.png";